import * as React from 'react';

var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgWhaleIcon = function SvgWhaleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "zig-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_587_12079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 5.33341C15.1653 4.3903 16.4444 11.6943 12.8889 14.6667C11.6636 15.6912 10.2222 15.9863 9.33333 15.9863C8.27956 15.9863 4.876 16.0001 3.55556 16.0001C0.364445 16.0001 0 13.8112 0 11.1112C0 8.41119 0.364445 6.2223 3.55556 6.2223C6.22222 6.2223 8 7.11119 9.33333 7.9983C11.5453 9.4703 11.9964 9.7143 12.8889 8.88896C14.3169 7.56896 13.3333 6.2223 14.2222 5.33341Z",
    fill: "#3B88C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1124 10.2222C14.9057 11.8786 14.2053 13.5657 12.8888 14.6666C11.6635 15.6911 10.2222 15.9862 9.33329 15.9862C8.27952 15.9862 4.87596 15.9999 3.55552 15.9999C1.76218 15.9999 0.861295 15.3088 0.41685 14.2239C0.0697392 13.3786 1.77774 14.6666 6.66663 14.6666C12.8888 14.6666 14.2222 12.4444 15.1124 10.2222Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 6.22213C16.0547 6.22213 16 3.99991 16 3.11102C16 2.22213 15.1111 3.55547 13.7778 3.99991C12.4444 4.44435 10.6667 3.11102 11.1111 3.99991C11.5556 4.8888 12.4444 6.22213 14.2222 6.22213Z",
    fill: "#3B88C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44428 3.11121C4.44428 4.09299 4.04606 5.77788 3.55539 5.77788C3.06473 5.77788 2.6665 4.09299 2.6665 3.11121C2.6665 2.12943 3.06473 2.22232 3.55539 2.22232C4.04606 2.22232 4.44428 2.12943 4.44428 3.11121Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55534 2.22212C3.55534 0.888789 0.888672 1.33323 0.888672 2.22212C0.888672 3.11101 2.22201 2.66657 2.66645 3.55546C3.11089 4.44434 3.55534 2.22212 3.55534 2.22212ZM3.55534 2.22212C3.55534 0.888789 6.22201 1.33323 6.22201 2.22212C6.22201 3.11101 4.88867 2.66657 4.44423 3.55546C3.99978 4.44434 3.55534 2.22212 3.55534 2.22212Z",
    fill: "#55ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.88883 12.0001C3.25702 12.0001 3.5555 11.7016 3.5555 11.3334C3.5555 10.9652 3.25702 10.6667 2.88883 10.6667C2.52064 10.6667 2.22217 10.9652 2.22217 11.3334C2.22217 11.7016 2.52064 12.0001 2.88883 12.0001Z",
    fill: "#292F33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_587_12079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};

export { SvgWhaleIcon as ReactComponent };
